import { queryOptions } from '@tanstack/react-query';
import { axios } from '@/lib/utils/axios';

import type { RoleType } from '../../common/permission';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type PermissionRolesListSuccessResponseType = {
	roles: RoleType[];
};

async function getListRoles(): Promise<PermissionRolesListSuccessResponseType | null> {
	const response = await axios.get(`${API_URLS.PERMISSIONS.ROLES}`);
	return getResponse<PermissionRolesListSuccessResponseType>(response.data);
}

export function getListRolesOption(enabled = true) {
	return queryOptions({
		queryKey: ['permissions', 'roles', 'list'],
		queryFn: () => getListRoles(),
		enabled,
	});
}
